module.exports = __webpack_public_path__ + "img/Logo-15.b055d4a0.svg";